export default __webpack_public_path__ + "static/rs-empresarial_03-33d554a4e2990577254880c28590f936.png";